import { render, staticRenderFns } from "./ContractCurrent.vue?vue&type=template&id=0f70d813&"
import script from "./ContractCurrent.vue?vue&type=script&lang=js&"
export * from "./ContractCurrent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports